import { render, staticRenderFns } from "./DocRepaymentExport.vue?vue&type=template&id=b2a36450"
import script from "./DocRepaymentExport.vue?vue&type=script&lang=js"
export * from "./DocRepaymentExport.vue?vue&type=script&lang=js"
import style0 from "./DocRepaymentExport.vue?vue&type=style&index=0&id=b2a36450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports